import React from 'react';
import { Box, Typography, Button, Card, CardContent, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useDispatch, useSelector } from 'react-redux';
import { usePutOperationMutation } from 'redux/api/operationApi';
import { OperationStatus } from 'Enums/OperationStatus';
import { clearCurrentOperation } from 'redux/features/operationSlice';
import { resetStep } from 'redux/features/stepperSlice';
import { useIntl } from 'react-intl';

const SuccessComponent: React.FC<{ previousStep: () => void }> = ({ previousStep }) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const [updateOperation, { data: postedOperationData, isSuccess: isPostedOperationSuccess, error: apiError }] = usePutOperationMutation()

    const operation = useSelector((state: any) => {
        return state.operationState?.currentOperation?.data || state.operationState?.currentOperation;
    })
    if (!operation) { return <p>{formatMessage({ id: "finish.operation.not.active" })}</p>; }

    const handleFinish = () => {
        const updatedOperation = {
            ...operation,
            status: OperationStatus.COMPLETED,
        }
        const formData = new FormData();
        formData.append("data", JSON.stringify(updatedOperation));
        updateOperation({ id: operation.id, operationToUpdate: formData }).then((res) => {
            if ('data' in res) {
                dispatch(clearCurrentOperation());
                dispatch(resetStep());
            }
        })
    }
    return (
        <Card sx={{ p: 2, mt:2 }}>

            <CardContent>
                <Box
                    sx={{
                        maxWidth: '400px',
                        margin: '0 auto',
                        padding: '20px',
                        backgroundColor: '',
                        textAlign: 'center',
                        height: '70vh',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexGrow: 1,
                        }}
                    >
                        {/* Ícono de confirmación */}
                        <CheckCircleIcon
                            sx={{
                                fontSize: '80px',
                                color: 'green',
                                marginBottom: '20px',
                            }}
                        />

                        {/* Mensaje */}
                        <Typography
                            sx={{
                                fontSize: '26px',
                                fontWeight: 'bold',
                                marginBottom: '40px',
                            }}
                        >
                            {formatMessage({ id: "finish.operation.success" })}
                        </Typography>
                    </Box>


                    {/* Botón Finalizar */}

                    <Grid container spacing={2} >
                        <Grid item xs={12} lg={6}>
                            <Button
                                variant="outlined"
                                color="secondary"
                                fullWidth
                                onClick={previousStep}
                                sx={{
                                    mt: 2,
                                    backgroundColor: "#FFF",
                                    display: {
                                        xs: "none", // Ocultar en pantallas pequeñas (móviles)
                                        sm: "none", // Ocultar en tablets
                                        md: "block", // Mostrar en pantallas medianas y grandes
                                    },
                                }}
                            >
                                {formatMessage({ id: "buttons.back" })}
                            </Button>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={handleFinish}
                                sx={{
                                    mt: 2,
                                    backgroundColor: "black",
                                    color: "white",
                                    fontWeight: "bold",
                                    "&:hover": {
                                        backgroundColor: "#333",
                                    },
                                }}
                            >
                                {formatMessage({ id: "buttons.end" })}
                            </Button>
                        </Grid>
                    </Grid>
                </Box>

            </CardContent>
        </Card>
    );
};

export default SuccessComponent;
